import * as React from 'react'
import app from 'firebase/app'
import 'firebase/messaging'

import FirebaseContext from '../../../contexts/FirebaseContext'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
}

const vapidKey =
  'BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4'

export const withFirebase = Component => props => (
  <FirebaseContext.Consumer>
    {firebase => <Component {...props} firebase={firebase} />}
  </FirebaseContext.Consumer>
)

class Firebase extends React.Component {
  constructor(props) {
    super(props)
    if (!app.apps.length) {
      app.initializeApp(firebaseConfig)
      try {
        if (typeof window !== 'undefined') {
          this.firebaseMessaging = app.messaging()
          app.messaging().usePublicVapidKey(vapidKey)
        }
      } catch (e) {
        console.debug('error', e)
      }
    }
  }
}

export default Firebase
